<div class="wrapper">
  <div class="container">
    <div class="frame">
      <div class="header"><ng-content select="[header]"></ng-content></div>
      <div class="content">
        <ng-content select="[button]"></ng-content>
      </div>
    </div>  
  </div>
</div>